import { Redirect, Route, Switch } from 'react-router-dom';
import { IonApp, IonRouterOutlet, setupIonicReact } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import Home from './pages/Home';
import TestInstruction from './pages/TestInstruction';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Info from './pages/Info';
import { createBrowserHistory } from 'history';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */
import './theme/variables.css';

setupIonicReact();
export const customHistory = createBrowserHistory();

const App: React.FC = () => {
  return (
    <IonApp>
      <IonReactRouter history={customHistory}>
        <IonRouterOutlet>
          <Switch>
            <Route exact path="/info">
              <Info/>
            </Route>
            <Route exact path="/privacyPolicy">
              <PrivacyPolicy />
            </Route>
            <Route exact path="/testInstruction/:id">
              <TestInstruction />
            </Route>
            <Route exact path="/home" component={Home} />
            <Route exact path="/">
              <Redirect to="/home" />
            </Route>
          </Switch>
        </IonRouterOutlet>
      </IonReactRouter>
    </IonApp>
  );
  
  };

export default App;
